import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EntityType } from '../../types.generated';
import { BrowsableEntityPage } from '../browse/BrowsableEntityPage';
import LineageExplorer from '../lineage/LineageExplorer';
import useIsLineageMode from '../lineage/utils/useIsLineageMode';
import { useEntityRegistry } from '../useEntityRegistry';
import analytics, { EventType } from '../analytics';
import { decodeUrn } from './shared/utils';

interface RouteParams {
    urn: string;
}

interface Props {
    entityType: EntityType;
}

export const EntityPage = ({ entityType }: Props) => {
    const { urn: encodedUrn } = useParams<RouteParams>();
    const urn = decodeUrn(encodedUrn);
    const entityRegistry = useEntityRegistry();
    const entity = entityRegistry.getEntity(entityType);
    const isBrowsable = entity.isBrowseEnabled();
    const isLineageSupported = entity.isLineageEnabled();
    const isLineageMode = useIsLineageMode();

    useEffect(() => {
        analytics.event({
            type: EventType.EntityViewEvent,
            entityType,
            entityUrn: urn,
        });
    }, [entityType, urn]);

    const Component = entityRegistry.renderProfile(entityType, urn);

    return isLineageMode && isLineageSupported ? (
        <BrowsableEntityPage
            isBrowsable={isBrowsable}
            urn={urn}
            type={entityType}
            lineageSupported={isLineageSupported}
        >
            <LineageExplorer type={entityType} urn={urn} />
        </BrowsableEntityPage>
    ) : (
        Component
    );
};
